import React, { useEffect, useState } from 'react';
import Modal from '../components/Modal/Modal';
import AddEntity from '../components/AddEntity/AddEntity';
import ApiManager from '../ApiManager/ApiManager';

const NewUser = () => {
    const [isModalOpen, setModalOpen] = useState(false);
    const [roleOptions, setRoleOptions] = useState([]);
    const [roleMap, setRoleMap] = useState([]);
    const [userFields, setUserFields] = useState([]);


    useEffect(() => {
        fetchRoles();
    }, []);
    
    const fetchRoles = async () => {
        try {
            const params = new URLSearchParams({
                page_size: 1000,
                page: 1,
              });
            const response = await ApiManager.getAllRoles(params);
            if (!response.ok) throw new Error('Network response was not ok');
            const json = await response.json();
            const roleNames = json.map((role) => role.name);
            const roleIdMap = json.reduce((map, role) => {
                map[role.name] = role.id;
                return map;
            }, {});
            setRoleOptions(roleNames);
            setRoleMap(roleIdMap);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    useEffect(() => {
        setUserFields([
            ...(roleOptions.length > 0
                ? [{ label: 'Role', name: 'role_id', type: 'picklist', required: true, options: roleOptions }]
                : [{ label: 'Role', name: 'role_id', type: 'picklist', required: true, options: []}]),
                { label: 'Username', name: 'username', type: 'text', required: true},
                { label: 'Email', name: 'email', type: 'text', required: true},
                { label: 'Password', name: 'password', type: 'text', required: true},
        ]);
    },[roleOptions]);

    const toggleModal = () => {
        setModalOpen(!isModalOpen);
    };


    const handleAddUser = async (formData) => {
        const roleId = roleMap[formData.role_id];
        const updatedFormData = { ...formData, role: {id: roleId}};

        const response = await ApiManager.addUser(updatedFormData);
        return response;
    };
    

    return (
        <div>
                <button className="custom-button" onClick={toggleModal}>
                    New User
                </button>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <AddEntity
                    toggleFunction={toggleModal}
                    title="Add User"
                    formFields={userFields}
                    apiFunction={handleAddUser}
                />
            </Modal>
        </div>
    );
};

export default NewUser;
